import React, { Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';
import { Bars3Icon, UserCircleIcon } from '@heroicons/react/24/outline';
import { useAuth } from '../../contexts/AuthContext';
import NotificationPanel from '../notifications/NotificationPanel';

const Header = ({ user, onMenuClick }) => {
  const { logout } = useAuth();

  return (
    <div className="relative z-10 flex-shrink-0 flex h-16 bg-white shadow">
      {/* Menu button (visible on all screen sizes) */}
      <button
        type="button"
        className="px-3 sm:px-4 border-r border-gray-200 text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500 hover:text-gray-700 hover:bg-gray-50 touch-friendly"
        onClick={onMenuClick}
        title="Toggle menu"
      >
        <Bars3Icon className="h-6 w-6" />
      </button>
      
      
      <div className="flex-1 px-2 sm:px-4 flex justify-between items-center">
        <div className="flex-1 flex items-center">
          {/* Mobile app title */}
          <div className="lg:hidden">
            <h1 className="text-lg font-medium text-gray-900 truncate">
              Rental Management
            </h1>
          </div>
        </div>
        
        <div className="ml-2 flex items-center space-x-4">
          {/* Notification Panel */}
          <NotificationPanel />

          <Menu as="div" className="relative">
            <div>
              <Menu.Button className="max-w-xs bg-white flex items-center text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 touch-friendly">
                <span className="sr-only">Open user menu</span>
                <UserCircleIcon className="h-8 w-8 text-gray-400" />
                <span className="hidden sm:block ml-2 text-sm font-medium text-gray-700 truncate max-w-[100px]">
                  {user?.firstName}
                </span>
              </Menu.Button>
            </div>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
            >
              <Menu.Items className="origin-top-right absolute right-0 mt-2 w-48 sm:w-56 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-50">
                <Menu.Item>
                  {({ active }) => (
                    <div className="px-4 py-3 text-sm text-gray-700 border-b border-gray-100">
                      <div className="font-medium truncate">{user?.firstName} {user?.lastName}</div>
                      <div className="text-gray-500 text-xs mt-1">{user?.role}</div>
                      {user?.organization?.name && (
                        <div className="text-gray-500 text-xs mt-1 truncate">
                          {user.organization.name}
                        </div>
                      )}
                    </div>
                  )}
                </Menu.Item>
                <Menu.Item>
                  {({ active }) => (
                    <button
                      onClick={logout}
                      className={`${
                        active ? 'bg-gray-100' : ''
                      } block w-full text-left px-4 py-3 text-sm text-gray-700 hover:bg-gray-50 transition-colors touch-friendly`}
                    >
                      Sign out
                    </button>
                  )}
                </Menu.Item>
              </Menu.Items>
            </Transition>
          </Menu>
        </div>
      </div>
    </div>
  );
};

export default Header;